import { useToast } from 'native-base';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import PaymentInit from './PaymentInit';
import optimalPay from '../../../helpers/optimalPay';
import store from '../../../store';

function PaymentInitContainer({ onStepSet }) {
  const [inputValue, setInputValue] = useState('');
  const cost = Math.round(
    +inputValue.replace('€', '').replace(',', '.').replace(' ', '') * 100,
  );
  const walletContent = useSelector((state) => state.wallet.walletContent);
  const walletTotal = useSelector(store.select.wallet.walletTotal);
  const toast = useToast();
  const onDone = useCallback(() => {
    if (Number.isNaN(cost) || cost <= 0) {
      toast.show({
        title: "Le montant indiqué n'est pas valide.",
        placement: 'top',
        status: 'error',
      });
    } else if (walletTotal < cost) {
      toast.show({
        title: 'Le montant du paiement est supérieur au montant disponible.',
        placement: 'top',
        status: 'error',
      });
    } else {
      store.dispatch.wallet.costSet(cost);
      store.dispatch.wallet.paymentClear();
      store.dispatch.wallet.returnClear();
      const paymentContent = optimalPay(cost, walletContent);
      store.dispatch.wallet.paymentSet(paymentContent);
      onStepSet(2);
    }
  }, [cost, onStepSet, toast, walletContent, walletTotal]);
  return (
    <PaymentInit
      inputValue={inputValue}
      onDone={onDone}
      onInputValueChange={setInputValue}
    />
  );
}

PaymentInitContainer.propTypes = {
  onStepSet: PropTypes.func.isRequired,
};

export default PaymentInitContainer;
